module.exports = __webpack_public_path__ + "static/img/step-1-image.33b0ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/faqNew/img/step-1-image.png
// module id = C5HD
// module chunks = 1